import { createContext, useContext } from 'react'

/**
 * Lets deep children (e.g. image attachments) ask the message list to scroll to
 * the bottom once they change height — images only know their size after load.
 */
export const ChatScrollContext = createContext<{ scrollToBottom: () => void }>({ scrollToBottom: () => {} })

export const useChatScroll = () => useContext(ChatScrollContext)
